"use client";

import React from "react";
import { X, Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForCoachesAndConsultants — Section 2: Problem-Lösung-Split
 * Drop-in für: src/pages/WebsiteForCoachesAndConsultants/sections/WhyChooseOurVenues.tsx
 */

const problems = ["Klienten googeln Sie — und finden nichts", "Ohne Website fehlt der erste Vertrauensbeweis", "Ihre Honorare wirken weniger nachvollziehbar"];
const solutions = ["Eigene Über-mich-Seite mit Qualifikationen & Story", "Pakete & Preise transparent darstellen", "Direkt-Buchung über Calendly oder Kontaktformular"];
export default function WhyChooseOurVenues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-5xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6 leading-tight">
              Vertrauen entsteht online — bevor das erste Gespräch stattfindet
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Potenzielle Klienten recherchieren Sie, bevor sie buchen. Ohne
              eigene Website fehlt der wichtigste Vertrauensbeweis: Ihre
              Geschichte, Ihre Qualifikationen, Ihre Persönlichkeit.
            </p>
            <ul className="space-y-4">
              {problems.map((p, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-500 shrink-0">
                    <X className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{p}</span>
                </li>)}
            </ul>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-primary mb-6 leading-tight">
              Mit PAGEMAKER24 in einer Stunde online
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Eine eigene Website mit eigener Domain signalisiert sofort: «Ich
              bin etabliert, ich meine es ernst.» Das rechtfertigt auch höhere
              Honorare.
            </p>
            <ul className="space-y-4">
              {solutions.map((s, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-600 shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{s}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}